"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _constants = require("../constants");
var _obj;
// text field
var styleOverrides = {
    root: {
        borderTopLeftRadius: 24,
        borderTopRightRadius: 24,
        borderRadius: 24,
        // eslint-disable-next-line @typescript-eslint/naming-convention -- css selector
        'input::placeholder': {
            opacity: 1,
            transition: 'none'
        },
        // eslint-disable-next-line @typescript-eslint/naming-convention -- css selector
        'label + &': {
            marginTop: 15
        },
        backgroundColor: _constants.colors.oriGrey[100]
    },
    input: {
        padding: '14px 17px'
    },
    sizeSmall: {
        paddingTop: 6,
        paddingBottom: 6
    },
    adornedStart: _define_property({}, "& .".concat(_material.filledInputClasses.input), {
        paddingLeft: 0
    }),
    adornedEnd: _define_property({}, "& .".concat(_material.filledInputClasses.input), {
        paddingRight: 0
    }),
    multiline: (_obj = {}, _define_property(_obj, "&.".concat(_material.filledInputClasses.sizeSmall), {
        paddingTop: 6,
        paddingBottom: 6
    }), _define_property(_obj, "padding", '14px 15px'), _obj)
};
var defaultProps = {
    disableUnderline: true,
    color: 'inputElements'
};
var _default = exports.default = {
    defaultProps: defaultProps,
    styleOverrides: styleOverrides
}; //# sourceMappingURL=MuiFilledInput.js.map
